"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPanelOrders = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const UserPanelLayout_1 = require("./views/UserPanelLayout");
const UserPanelOrdersView_1 = require("./views/UserPanelOrdersView");
function UserPanelOrders({ logo }) {
    const { data } = (0, app_1.useQuery)('getOrders', {
        select: {
            secret: true,
            status: true,
            items: true,
            number: true,
            total: true,
        },
    });
    return ((0, jsx_runtime_1.jsx)(UserPanelLayout_1.UserPanelLayout, Object.assign({ logo: logo }, { children: (0, jsx_runtime_1.jsx)(UserPanelOrdersView_1.UserPanelOrdersView, { orders: data !== null && data !== void 0 ? data : [] }) })));
}
exports.UserPanelOrders = UserPanelOrders;
